import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { keyBy } from 'lodash';
import DiscoverRowWrapper from './DiscoverRowWrapper';
import CollectionSlider from '../../components/widgets/CollectionSlider';

const CustomDiscoverRow = (props) => {
    const {
        index,
        currentCategory,
        collectionsById,
        userCollections,
        userCollectionsByCollectionId,
        collectionLoading,
        userCompany,
        isCollectionsOrderLocked,
        recommendedCollections = [],
        assignedCollections = [],
        handleRecommendationModalOpen,
        onCardClick,
        categories,
    } = props;

    const recommendedAndAssignedCollections = useMemo(
        () => [...recommendedCollections, ...assignedCollections],
        [recommendedCollections, assignedCollections]
    );

    // TODO: This if block does not belong here, and the length check is a quick bugfix.
    //  We will revisit when we convert this page to the Discover page.
    if (currentCategory.type === 'RECOMMENDED_COLLECTIONS') {
        return recommendedAndAssignedCollections.length ? (
            <DiscoverRowWrapper
                currentCategory={currentCategory}
                index={index}
                categories={categories}
                userCompany={userCompany}
            >
                <CollectionSlider
                    handleRecommendationModalOpen={handleRecommendationModalOpen}
                    onCardClick={onCardClick}
                    userCollections={recommendedAndAssignedCollections}
                    loading={collectionLoading}
                    currentCategory={currentCategory}
                />
            </DiscoverRowWrapper>
        ) : null;
    }
    const categoryCollections = currentCategory.content.reduce((acc, collectionId) => {
        if (collectionsById[collectionId]) {
            acc.push(collectionsById[collectionId]);
        }
        return acc;
    }, []);
    const categoryCollectionsById = keyBy(categoryCollections, '_id');
    const categoryUserCollections = userCollections.filter(
        (collection) => !!categoryCollectionsById[collection.collectionId]
    );
    const notStartedCollections = categoryCollections.filter(
        (collection) => !userCollectionsByCollectionId[collection._id]
    );

    return (
        <DiscoverRowWrapper
            currentCategory={currentCategory}
            index={index}
            userCompany={userCompany}
            categories={categories}
        >
            <CollectionSlider
                isCollectionsOrderLocked={isCollectionsOrderLocked}
                orderedCollections={isCollectionsOrderLocked ? categoryCollections : undefined}
                handleRecommendationModalOpen={handleRecommendationModalOpen}
                onCardClick={onCardClick}
                userCollections={categoryUserCollections}
                collections={notStartedCollections}
                loading={collectionLoading}
            />
        </DiscoverRowWrapper>
    );
};

CustomDiscoverRow.propTypes = {
    currentCategory: PropTypes.object,
    userCompany: PropTypes.object,
    index: PropTypes.number,
    collectionsById: PropTypes.object,
    userCollections: PropTypes.array,
    userCollectionsByCollectionId: PropTypes.object,
    collectionLoading: PropTypes.bool,
    isCollectionsOrderLocked: PropTypes.bool,
    recommendedCollections: PropTypes.array,
    assignedCollections: PropTypes.array,
    handleRecommendationModalOpen: PropTypes.func,
    onCardClick: PropTypes.func,
    categories: PropTypes.object,
};

export default CustomDiscoverRow;
